import StripeFinancialConnectionsButton from '@apps/team/admin/components/stripe_financial_connections_button'
import AffiliateNotificationsToken from '@apps/maha/admin/tokens/affiliate_notifications'
import ShortLink from '@admin/components/shortlink'
import CopyText from '@admin/components/copytext'
import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import Edit from '../../affiliate/edit'
import PropTypes from 'prop-types'
import React from 'react'

class Overview extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    flash: PropTypes.object
  }

  static propTypes = {
    affiliate: PropTypes.object
  }

  render() {
    const { affiliate } = this.props

    const shortlink = {
      shortlink: affiliate.shortlink,
      text: 't(Share this signup page)',
      title: 't(Affiliate Signup Page)',
      components: [
        { component: <CopyText content={ affiliate.shortlink.expanded_url } button="t(Copy Link)" /> }
      ]
    }

    const details = {
      before: <ShortLink { ...shortlink } />,
      sections: [
        {
          title: 't(Affiliate Details)',
          items: [
            { label: 't(Active Referrals)', content: (
              <>{affiliate.active_referrals_count} / {affiliate.referrals_count}</>
            ) },
            ...(affiliate.stripe_bank_account_id ? [
              { label: 't(Bank Account)', content: (
                <>
                  { affiliate.bank_name } - { affiliate.bank_last_four }
                  { ' - ' }
                  <Button { ...this._getRemoveButton() } />
                </>
              ) }
            ] : [
              { label: 't(Bank Account)', content: (
                <span>
                  <span style={ { color: '#f2711c' } }>
                    <i className="fa fa-exclamation-triangle" /> Not connected
                  </span>
                  { ' - ' }
                  <StripeFinancialConnectionsButton />
                </span>
              ) }
            ]),
            { label: 't(Commission Rate)', content: affiliate.rate, format: 'rate' },
            { label: 't(Notifications)', content: <AffiliateNotificationsToken value={ affiliate.notifications } /> }
          ]
        }
      ]
    }

    return <Details { ...details } />
  }

  _getRemoveButton() {
    const { flash } = this.context
    return {
      label: 't(Remove Account)',
      className: 'link',
      confirm: 't(Are you sure you want to remove this bank account? You will need to reconnect to receive payouts.)',
      request: {
        endpoint: '/api/admin/team/affiliate/bank',
        method: 'DELETE',
        onFailure: () => flash.set('error', 't(Unable to remove bank account)'),
        onSuccess: () => flash.set('success', 't(Bank account was removed successfully)')
      }
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Affiliate)',
  panel: <Overview affiliate={ props.affiliate } />,
  tasks: {
    items: [
      { label: 't(Edit Affiliate)', svg: 'square_pen', modal: Edit }
    ]
  }
})

const mapResourcesToPanel = (props, context) => ({
  affiliate: '/api/admin/team/affiliate'
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
